import React, { PropsWithChildren } from 'react';
import CalendarDay from '@app/state/calendar/CalendarDay';
import Utilities from '@util/Utilities';
import Tag from '@app/component/tag/Tag';
import Spinner from '@app/component/static/Spinner';
import {
	useMarketStateTools,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/hook/useMarketStateTools';
import {
	useFindMarketStateNotificationsForStatDate,
} from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/hook/useFindMarketStateNotificationsForStatDate';
import AlertIndicator from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/_calendar/fragment/AlertIndicator';
import MarketStateDailySnapshotState
	from '@app/site/secured/rateshopper/rates/dashboard/fragment/__market-state/common/MarketStateDailySnapshotState';
import {
	useLatestProcessRequestExecutionStateMonitor,
} from '@app/site/secured/rateshopper/rates/provider/useLatestProcessRequestExecutionStateMonitor';

export const MarketStateSnapshotCalendarDayForMobile: React.FunctionComponent<{
	marketStateDailySnapshotState: MarketStateDailySnapshotState,
	selectedCalendarDay: CalendarDay | undefined,
	setSelectedCalendarDay: (calendarDay: CalendarDay) => any,
}> = ({
				marketStateDailySnapshotState,
				selectedCalendarDay,
				setSelectedCalendarDay,
			}) => {
	const tools = useMarketStateTools();
	const marketStateNotificationsForDay = useFindMarketStateNotificationsForStatDate(marketStateDailySnapshotState.calendarDay.display);
	const monitor = useLatestProcessRequestExecutionStateMonitor();

	const onSelect = () => {
		if (!monitor.isInteractionLocked)
			setSelectedCalendarDay(marketStateDailySnapshotState.calendarDay);
	};

	if (!marketStateDailySnapshotState.marketStateDailySnapshot) return <RenderButton
		marketStateDailySnapshotState={marketStateDailySnapshotState}
		selectedCalendarDay={selectedCalendarDay} />;

	const marketStateDailyMainHotelSnapshot = marketStateDailySnapshotState.marketStateDailySnapshot.current.findDailyMainHotelSnapshot();


	if (!marketStateDailyMainHotelSnapshot || !marketStateDailySnapshotState.marketStateDailySnapshot.current) return <RenderButton
		marketStateDailySnapshotState={marketStateDailySnapshotState}
		selectedCalendarDay={selectedCalendarDay} />;

	return <RenderButton marketStateDailySnapshotState={marketStateDailySnapshotState}
											 selectedCalendarDay={selectedCalendarDay}
											 alertIndicator={<AlertIndicator
												 marketStatDateCompetitorSnapshot={marketStateDailyMainHotelSnapshot}
												 calendarDay={marketStateDailySnapshotState.calendarDay}
												 marketStateNotificationsForDay={marketStateNotificationsForDay} type="DOT" />}
											 onSelect={onSelect}>
		{marketStateDailySnapshotState.marketStateDailySnapshot!.current!.evaluatePriceMedian(tools.companyHotel)!.map((result, idx) =>
			<div key={`index_${idx}`} className="flex items-center justify-end"><Tag state={result.state}>{result.value}</Tag></div>)}
	</RenderButton>;
};

const RenderButton: React.FunctionComponent<PropsWithChildren<{
	marketStateDailySnapshotState: MarketStateDailySnapshotState,
	selectedCalendarDay: CalendarDay | undefined,
	alertIndicator?: React.ReactNode
	onSelect?: () => void
}>> = ({ marketStateDailySnapshotState, selectedCalendarDay, alertIndicator, onSelect, children }) => {
	return <button type="button" onClick={onSelect}
								 id={`calendar-day-mobile-${marketStateDailySnapshotState.calendarDay.display}`}
								 className={Utilities.classNames('text-gray-900 flex flex-col px-1.5 py-1.5 hover:bg-gray-100 focus:z-10', (marketStateDailySnapshotState.calendarDay.isPreviousMonth || marketStateDailySnapshotState.calendarDay.isNextMonth) ? 'bg-gray-50 text-gray-500' : 'bg-white')}>
		{(!marketStateDailySnapshotState.isUpdating || marketStateDailySnapshotState.calendarDay.isPast) && <>
			<div className="flex justify-end items-center w-full mb-2">
				{!!alertIndicator && alertIndicator}
				<time dateTime={marketStateDailySnapshotState.calendarDay.display}
							className={Utilities.classNames('ml-auto', (!selectedCalendarDay || selectedCalendarDay.display !== marketStateDailySnapshotState.calendarDay.display) && marketStateDailySnapshotState.calendarDay.isToday ? 'h-6 w-6 items-center justify-center rounded-full bg-gray-900 text-white' : '', selectedCalendarDay && selectedCalendarDay.display === marketStateDailySnapshotState.calendarDay.display ? 'h-6 w-6 items-center justify-center rounded-full bg-blue-600 text-white' : '')}>{marketStateDailySnapshotState.calendarDay.index.day}</time>
			</div>
			{children}
		</>
		}
		{marketStateDailySnapshotState.isUpdating && !marketStateDailySnapshotState.calendarDay.isPast && <>
			<div className="flex self-center"><Spinner /></div>
		</>}
	</button>;
};
